import './index.css';
import './i18n';

import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import Loading from '@/components/Loading';
import router from '@/router';
import theme from '@/theme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
    </ChakraProvider>
  </StrictMode>
);
